export default __webpack_public_path__ + "static/media/terminal.1e6b9db0.webp";